/* tslint:disable */
/* eslint-disable */
/**
 * Business Portal API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UploadAccountCsv200Response
 */
export interface UploadAccountCsv200Response {
    /**
     * アカウントIDの一覧
     * @type {Array<string>}
     * @memberof UploadAccountCsv200Response
     */
    accountIds: Array<string>;
}

/**
 * Check if a given object implements the UploadAccountCsv200Response interface.
 */
export function instanceOfUploadAccountCsv200Response(value: object): value is UploadAccountCsv200Response {
    if (!('accountIds' in value) || value['accountIds'] === undefined) return false;
    return true;
}

export function UploadAccountCsv200ResponseFromJSON(json: any): UploadAccountCsv200Response {
    return UploadAccountCsv200ResponseFromJSONTyped(json, false);
}

export function UploadAccountCsv200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): UploadAccountCsv200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'accountIds': json['account_ids'],
    };
}

export function UploadAccountCsv200ResponseToJSON(json: any): UploadAccountCsv200Response {
    return UploadAccountCsv200ResponseToJSONTyped(json, false);
}

export function UploadAccountCsv200ResponseToJSONTyped(value?: UploadAccountCsv200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'account_ids': value['accountIds'],
    };
}

